import { connect } from 'react-redux';
import RegisterModal from '../../components/RegisterModal';
import { 
    loginRequest, 
    registerRequest, 
    cleanErrorRegister,
    cleanExternalLogin
} from '../../actions/auth';
import { getPermissionType } from '../../actions/profile';

interface RegisterModalContainerProps {
    open: boolean;
    onClose: () => void;
    onSwitchToLogin: () => void;
    isGoogleLogin?: boolean;
}

const mapStateToProps = (state: any) => ({
    authFetching: state.auth.fetching,
    register: state.auth.register,
    externalUser: state.auth.externalUser,
    externalLogin: state.auth.externalLogin,
    permissionType: state.profile.permissionsType.data
});

const mapDispatchToProps = (dispatch: any) => ({
    loginRequest: (data: any) => dispatch(loginRequest(data)),
    registerRequest: (data: any) => dispatch(registerRequest(data)),
    cleanErrorRegister: () => dispatch(cleanErrorRegister()),
    cleanExternalLogin: () => dispatch(cleanExternalLogin()),
    getPermissionType: (type: string, action: string) => dispatch(getPermissionType(type, action))
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterModal);
